/**
 * @generated SignedSource<<2991bd13e12629a43a81f1e717670d7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Order_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Payment_query">;
  readonly " $fragmentType": "Order_query";
};
export type Order_query$key = {
  readonly " $data"?: Order_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Order_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Order_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Payment_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "6cf72181fe896560dfdf96aeba39def7";

export default node;
